/* eslint-disable max-len */
export default {
  Header: {
    Greeting: 'Good afternoon, #{userFirstName}',
    Summary: '#{todayDate} - #{numTasks} tasks due today - from plans across your records',
  },
  Sections: {
    NeedsYou: 'Needs you',
    AiHandling: 'AI handling',
  },
  Empty: 'No tasks for today.',
  TaskItem: {
    Types: {
      CARE_PLAN_REVIEW: 'Care plan',
      CALL: 'Call',
      DEBRIEF: 'Debrief',
      APPROVAL: 'Approval',
      RESOLVE: 'Resolve',
      REVIEW: 'Review',
      RESPOND: 'Respond',
      NEW_CLIENT_LEAD: 'New client lead',
      FOLLOW_UP: 'Follow up',
      MEET_GREET: 'Meet & greet',
      UNKNOWN: 'Unknown',
    },
    Description: {
      Empty: 'No description provided.',
    },
    Due: {
      Label: 'Due #{time}',
      YesterdayLabel: 'Due yesterday #{time}',
      DaysAgoLabel: 'Due #{days} days ago #{time}',
      None: 'No due date',
    },
    MoreClients: '+#{count} more',
    Lineage: {
      ParentSession: 'Created from session',
      TaskSession: 'Task session',
    },
  },
};
